import { StylesConfig } from 'react-select';
import colors from 'theme/colors';

export const selectStyles: StylesConfig = {
  control: (styles) => ({
    ...styles,
    minHeight: 25,
    border: 'none',
    borderRadius: 4,
    backgroundColor: `${colors.dark2}`,
    boxShadow: 'none',
    color: 'white',
    '@media (min-width: 768px)': {
      minHeight: 43,
    },
  }),
  option: (styles) => {
    return {
      ...styles,
      color: 'white',
      fontSize: 12,
      backgroundColor: `${colors.dark2}`,
      padding: 6,
      minWidth: 80,
      cursor: 'pointer',
      ':hover': { backgroundColor: `${colors.blue}` },
      '@media (min-width: 768px)': {
        fontSize: 14,
        padding: 10,
        minWidth: 90,
      },
    };
  },
  menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
  input: (styles) => {
    return { ...styles, color: 'white' };
  },
  menuList: (styles) => ({ ...styles, padding: 0, maxHeight: '164px' }),
  placeholder: (styles) => ({ ...styles, color: `${colors.gray1}`, fontSize: '14px' }),
  multiValue: (styles) => {
    return {
      ...styles,
      justifyContent: 'space-evenly',
      backgroundColor: `${colors.blue2}`,
      borderRadius: '27px',
      padding: '0 5px 0 3px',
    };
  },
  multiValueLabel: (styles) => {
    return {
      ...styles,
      color: 'white',
      whiteSpace: 'normal',
      wordBreak: 'break-all',
    };
  },
  singleValue: (styles) => ({
    ...styles,
    color: 'white',
  }),
  multiValueRemove: (styles) => {
    return {
      ...styles,
      flexShrink: 0,
      color: `${colors.dark4}`,
      cursor: 'pointer',
      ':hover': { color: 'white' },
    };
  },
  indicatorSeparator: () => ({ display: 'none' }),
  clearIndicator: (styles) => {
    return { ...styles, color: 'white', cursor: 'pointer', ':hover': { color: 'white' } };
  },
  dropdownIndicator: (styles) => {
    return { ...styles, color: 'white', cursor: 'pointer', ':hover': { color: 'white' } };
  },
  valueContainer: (styles) => {
    return {
      ...styles,
      gap: 6,
      '> div': {
        width: 'max-content!important',
      },
    };
  },
};
